import { TableCellPosition, EditorRange, Blot } from './editor';

export interface ThreadInfo {
  comments: number;
  notFound: boolean;
  unreadComments: number;
  targetDetails: {
    x: number;
    y: number;
    color: string;
  };
  thread: {
    attachmentId: string;
    blotId: string;
    createdAt: number;
    globalId: string;
    noteGlobalId: string;
    orgId: string;
    resolved: boolean;
    target: ThreadTargetType;
    updatedAt: number;
    userId: number;
    workspaceId: string;
  };
}

export interface ThreadEditor {
  attachmentId?: string;
  threadId: string;
  blotId: string;
  count: number;
  target?: ThreadTargetType;
  resolved?: boolean;
  notFound?: boolean;
  x?: number;
  y?: number;
  color?: string;
  unreadComments?: number;
}

export interface ThreadParams {
  text: string;
  threadId: string | null;
  target?: ThreadTargetType;
  ids?: string[];
  targetParams?: ThreadTargetParams | null;
}

export interface CommentUser {
  id: number;
  role: CommentUserRoles;
  orgId: string;
}

export enum CommentUserRoles {
  OWNER = 'owner',
  MANAGER = 'manager',
  MEMBER = 'member',
  CLIENT = 'client',
  GUEST = 'guest',
}

export interface CommentPluginContext {
  orgId: string;
  userId: number;
  userRole: CommentUserRoles;
  workspaceId: string;
  configurationKey?: string;
}

export interface ThreadContext {
  title: string;
  noteId?: string;
  targetId: string;
  targetType: ThreadTargetType | null;
  threadId: string | null;
  targetDetails?: ThreadTargetDetails;
  targetParams?: ThreadTargetParams | null;
}

export type ThreadTargetType = 'blot' | 'text' | 'image-point' | 'task' | 'cell';

export enum CommentColor {
  red = 'red',
  pink = 'pink',
  purple = 'purple',
  deeppurple = 'deep-purple',
  indigo = 'indigo',
  blue = 'blue',
  lightblue = 'light-blue',
  cyan = 'cyan',
  teal = 'teal',
  green = 'green',
  lightgreen = 'light-green',
  lime = 'lime',
  yellow = 'yellow',
  amber = 'amber',
  orange = 'orange',
  deeporange = 'deep-orange',
  brown = 'brown',
  grey = 'grey',
  bluegrey = 'blue-grey',
}

export interface ThreadTargetDetails {
  x: number;
  y: number;
  color: CommentColor;
}

export interface ThreadTargetParams {
  type: string;
  position?: TableCellPosition | null;
}

export interface SelectedBlotRange {
  selectedRange: EditorRange | null;
  selectedBlot: Blot | null;
  relatedBlot: Blot | null;
}

export interface ResoveThreadEvent {
  threadId: string;
}

export interface OpenThreadResult {
  threadId: string;
  isNew?: boolean;
}
